module.exports = __webpack_public_path__ + "img/collection-play-fill.ca2162d9.svg";